import { render, staticRenderFns } from "./JsCodeEditorDyn.vue?vue&type=template&id=0bd904a5"
import script from "./JsCodeEditorDyn.vue?vue&type=script&lang=js"
export * from "./JsCodeEditorDyn.vue?vue&type=script&lang=js"
import style0 from "./JsCodeEditorDyn.vue?vue&type=style&index=0&id=0bd904a5&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd904a5')) {
      api.createRecord('0bd904a5', component.options)
    } else {
      api.reload('0bd904a5', component.options)
    }
    module.hot.accept("./JsCodeEditorDyn.vue?vue&type=template&id=0bd904a5", function () {
      api.rerender('0bd904a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/dynamic/JsCodeEditorDyn.vue"
export default component.exports